
import api from '../../../services/api';

const userService = {
  // Get users, optionally filtered by firm, role, or active status
  async getUsers(filters = {}) {
    const response = await api.get('/users', {
      params: filters,
    });

    return response.data.data.users;
  },

  // Get a single user by ID
  async getUserById(userId) {
    const response = await api.get(`/users/${userId}`);
    return response.data.data.user;
  },

  // Create a distributor account for a firm
  async createUser(userData) {
    const response = await api.post('/users', userData);
    return response.data.data.user;
  },

  // Activate or deactivate a distributor account
  async updateUserStatus(userId, isActive) {
    const response = await api.patch(`/users/${userId}/status`, {
      is_active: isActive,
    });

    return response.data.data.user;
  },

  // Reset a distributor's password (Super Admin only)
  async resetUserPassword(userId, password) {
    const response = await api.patch(
      `/auth/users/${userId}/password`,
      { password }
    );

    return response.data.data.user;
  },
};

export default userService;
